import { render, staticRenderFns } from "./shiysm_app.vue?vue&type=template&id=b6dfda16&scoped=true&"
import script from "./shiysm_app.vue?vue&type=script&lang=js&"
export * from "./shiysm_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dfda16",
  null
  
)

export default component.exports